module.exports = __webpack_public_path__ + "static/media/revise.aaae6ff3.svg";